export type DashboardPacingStatus = "COMPLETE" | "INCOMPLETE" | "NO_DATA";

export type DashboardPacingRow = {
  id: string;
  label: string;
  percent: number;
  completed: number;
  total: number;
  status?: DashboardPacingStatus;
  statusLabel?: string;
  detailLabel?: string;
};

export const DASHBOARD_PACING_STATUS_LABELS: Record<DashboardPacingStatus, string> = {
  COMPLETE: "Complete",
  INCOMPLETE: "Incomplete",
  NO_DATA: "No Data"
};
